import Vue from 'vue'
import index from './index.vue'
import store from '../../store'
import components from '../../components'
import '../../assets/styles/atom.scss'
import rem from '@/utils/rem'
rem()
console.info('VERSION', process.env.VUE_APP_VERSION)
console.info('ENV', process.env.VUE_APP_ENV)

Vue.config.productionTip = false
Vue.use(components)

new Vue({
  store,
  render: h => h(index)
}).$mount('#login')
